module.exports = __webpack_public_path__ + "img/trackd-outline-embelem.7fc094a8.svg";